import React, { FC, ReactElement } from 'react';

import styles from './companyPollStyles.scss';

import PollQuestion from './PollQuestion/pollQuestion';
import PollResults from './PollResults/pollResults';
import { CompanyQuestion } from 'buyside/components/container/CompanyShow/BuysideConsensusContainer';

import { Maybe } from 'interfaces/graphql-typings';

const CompanyPoll: FC<{
  question: Maybe<CompanyQuestion>;
  answerPoll: (id: string, answers: string[]) => void;
  skipPoll: (id: string) => void;
  toggleMainArea: (boolean: boolean) => void;
}> = ({ question, answerPoll, skipPoll, toggleMainArea }): ReactElement => {
  return (
    <div className={styles.companyPoll}>
      <a
        className={styles.toggleLink}
        onClick={(): void => toggleMainArea(true)}
        data-heap="view-price-chart"
      >
        View price chart
      </a>
      {question ? (
        question.pollResponseData?.answeredByCurrentUser ? (
          <PollResults question={question} />
        ) : (
          <>
            <PollQuestion question={question} handleAnswer={answerPoll} handleSkip={skipPoll} />
            <div className={styles.bottomText}>
              Your responses are <strong>fully anonymous</strong>.
            </div>
          </>
        )
      ) : (
        <div className={styles.companyPollDone}>
          No more questions. View all questions and results in the chart area and check back later
          for more questions.
        </div>
      )}
    </div>
  );
};

export default CompanyPoll;
